import React from "react";
import { Card, Container } from "react-bootstrap";
import SwiperCore, { Navigation } from "swiper";
import Image from "components/image";
import { Swiper, SwiperSlide } from "swiper/react";

SwiperCore.use([Navigation]);

import {
  testimonials, testimonialFullWidth, testimonialCardContainer,
  testimonialCard, testimonialContent, newTestimonialTitle,
  newTestimonialDescription, testimonialImage, tcLink, 
  testimonialSlide, newTestimonialContent, newTestimonialCard, tcTitle,
  containerDesktopView, swiperMobileView, newTestimonials
} from "./style.mod.scss";
import useResponsiveConfig from "hooks/useResponsiveConfig";
import parsePadding from "helpers/parse-padding";

const TestimonialtsWithoutSlider = ({ data }) => {
  const { title, mobilePadding, tabletPadding, desktopPadding } = data;

  
  var settings = {
    loop: true,
    spaceBetween: 25,
    slidesPerView: 1,
    centeredSlides: true,
    autoHeight: true,
    pagination: false,
    navigation: { clickable: true },
  };

  const config = useResponsiveConfig({
    mobile: { styles: parsePadding(mobilePadding) },
    tablet: { styles: parsePadding(tabletPadding) },
    desktop: { styles: parsePadding(desktopPadding) }
  });


  return (
    <div className={`${testimonials} ${newTestimonials}`} style={{
      backgroundColor: data.bgColor && data.bgColor.hex,
      ...config.styles
    }}>
      <Container className={`${testimonialFullWidth} ${containerDesktopView}`}>
        {title.map( (tc) => (
          <div key={tc._key} className={testimonialSlide}>
            <div  className={testimonialCardContainer} >
              <a className={tcLink} href={tc.link}>
                <Card className={`${newTestimonialCard} ${testimonialCard}`} style={{ backgroundColor: data.testimonialBgColor && data.testimonialBgColor.hex }}>
                  <Card.Body className={`${testimonialContent} ${newTestimonialContent}`} >
                    <Card.Title className={newTestimonialTitle}>
                      <h2 className={tcTitle}>{tc.title}</h2> 
                    </Card.Title>
                    {/* <Card.Img srcSet={getImagePath(tc?.logo, true)} alt={tc.logo?.alt} className={testimonialImage}/> */}
                    <div className={testimonialImage}>
                      <Image image={tc?.logo} alt={tc.logo?.alt}/>
                    </div>
                    <Card.Text className={newTestimonialDescription}>
                      <span style={{ color: data.textColor && data.textColor.hex }}>{tc.content}</span>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </a>
            </div>
          </div>  
        ))}
      </Container>
      <Swiper {...settings} className={`${testimonialFullWidth} ${swiperMobileView}`}>
        {title.map( (tc) => (
          <SwiperSlide key={tc._key} className={testimonialSlide}>
            <div  className={testimonialCardContainer} >
              <a className={tcLink} href={tc.link}>
                <Card className={`${newTestimonialCard} ${testimonialCard}`} style={{ backgroundColor: data.testimonialBgColor && data.testimonialBgColor.hex }}>
                  <Card.Body className={`${testimonialContent} ${newTestimonialContent}`} >
                    <Card.Title className={newTestimonialTitle}>
                      <h2 className={tcTitle}>{tc.title}</h2> 
                    </Card.Title>
                    {/* <Card.Img srcSet={getImagePath(tc?.logo, true)} alt={tc.logo?.alt} className={testimonialImage}/> */}
                    <div className={testimonialImage}>
                      <Image image={tc?.logo} alt={tc.logo?.alt}/>
                    </div>
                    <Card.Text className={newTestimonialDescription}>
                      <span style={{ color: data.textColor && data.textColor.hex }}>{tc.content}</span>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </a>
            </div>
          </SwiperSlide>  
        ))}
      </Swiper>
    </div>
  );
};

export default TestimonialtsWithoutSlider;
